import React, {useState, useEffect, useRef} from "react";
import { getCameraToken, setCameraToken, setCameras, getCameras, getMonitorsGroupById, getCap, storeCap, getLatestUrls, storeLatestUrls, getUserInformation, getUser } from "../utils/Common";
import { 
    Button, 
    Glyphicon, 
    Collapse
} from "react-bootstrap";
import "./Camera.css";
// import { getMonitorStatus } from "../utils/cameraAPI";
import { loadCap, getLatestStoredImages, getMonitors, getImagesFromCapThroughCloud, recordUserAction, loginToCamerasThroughAPI, getMonitorAlarmStatus, postStreamControl } from "../utils/bedrockAPI";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import LoaderButton from "../components/LoaderButton";
import ReactPlayer from 'react-player/file';
import Hls from 'hls.js';

if (typeof window !== 'undefined' && !window.Hls) {
    window.Hls = Hls;
}

const UPDATE_INTERVAL = 2; // Everytime the background snapshot is loaded
const TIMEOUT = 120; // timeout so data doesn't balloon
// const TIMEOUT = 40;
const URL_BASE = "https://data.bedrockwireless.com:";
const STREAM_PLAYER_CONFIG = {
    file: {
        forceHLS: true,
        hlsOptions: {
            maxBufferLength: 30,
            maxMaxBufferLength: 60,
        },
    },
};

export default function Camera3(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [cap, setCap] = useState(null);
    const [renderError, setRenderError] = useState(false);
    const [localCameras, setLocalCameras] = useState([]);
    const [bigCamera, setBigCamera] = useState(null);
    const [mediumCamera, setMediumCamera] = useState(null);
    const [url, setUrl] = useState("");
    const [urlHigh, setUrlHigh] = useState("");
    const [savedUrl, setSavedUrl] = useState("");
    // const [latestStreamImage, setLatestStreamImage] = useState("");
    const [time, setTime] = useState(0);
    const [streaming, setStreaming] = useState(false);
    const [fullyLoaded, setFullyLoaded] = useState(false);
    const [streamQuality, setStreamQuality] = useState("low");
    const [streamTransition, setStreamTransition] = useState("none");
    const [lowSecondsLoaded, setLowSecondsLoaded] = useState(null);
    const [highSecondsLoaded, setHighSecondsLoaded] = useState(null);
    const [signalWeak, setSignalWeak] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [playPauseLoading, setPlayPauseLoading] = useState(false);
    const [changeStreamLoading, setChangeStreamLoading] = useState(false);
    const [showResolutionHelp, setShowResolutionHelp] = useState(false);
    const [imgDate, setImgDate] = useState(null);
    const [playing, setPlaying] = useState(false);
    const [view, setView] = useState(1);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const componentMounted = useRef(true);
    const playerRef = useRef();
    const playerRefHigh = useRef();
    const overlayRef = useRef();

    function toggleFullscreen() {
        const el = overlayRef.current;
        if(!el) return;
        if(!document.fullscreenElement && !document.webkitFullscreenElement) {
            if(el.requestFullscreen) {
                el.requestFullscreen();
            } else if(el.webkitRequestFullscreen) {
                el.webkitRequestFullscreen();
            }
        } else {
            if(document.exitFullscreen) {
                document.exitFullscreen();
            } else if(document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }

    function backToCaps() {
        props.history.push(`/caps/${props.match.params.capid}`);
    }

    // 1 - Start clocks
    useEffect(() => {
        const interval = setInterval(() => {
            setTime(time => time+1);
        },1000);

        return () => {
            clearInterval(interval);
            componentMounted.current = false;
        };
    },[]);

    // Overlay behavior: lock page scroll, close on Escape
    useEffect(() => {
        function handleKeyDown(e) {
            // While in browser fullscreen, Escape only exits fullscreen
            if(e.key === "Escape" && !document.fullscreenElement && !document.webkitFullscreenElement) {
                backToCaps();
            }
        }
        function handleFullscreenChange() {
            setIsFullscreen(Boolean(document.fullscreenElement || document.webkitFullscreenElement));
        }
        window.addEventListener("keydown", handleKeyDown);
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.body.classList.add("stream-overlay-open");
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
            document.body.classList.remove("stream-overlay-open");
        };
    },[]);

    // Don't let the user keep pulling live images while AFK
    useEffect(() => {
        if(streaming) {
            if(time > 0 && time%TIMEOUT===0) {
                // setTime(0);
                playPause(false);
            } else if(mediumCamera && time > 0 && time%UPDATE_INTERVAL===0) {
                // fetchAlarmStatus();
            }
            if(playerRef.current) {
                setLowSecondsLoaded(playerRef.current.getSecondsLoaded());
            }
            if(playerRefHigh.current) {
                setHighSecondsLoaded(playerRefHigh.current.getSecondsLoaded());
            }
            console.log(streamTransition,streamQuality,lowSecondsLoaded,highSecondsLoaded);
        }
    },[time]);

    useEffect(() => {
        setView(props.match.params.view);
    },[props.match.params.view]);

    // 2 - Load the cap from memory 1st then api
    useEffect(() => {
        async function accessCap() {
            try {
                setIsLoading(true);
                var tempCap = getCap();
                if(tempCap == null || tempCap.capId !== props.match.params.capid) {
                    tempCap = await loadCap(props.match.params.capid);
                    storeCap(tempCap);                    
                }
                setCap(tempCap);
                setIsLoading(false);
            } catch(e) {
                console.log(e);
            }
        }
        accessCap();
        recordUserAction(getUser().userId,"camera",props.match.params.capid,{'monitorId':props.match.params.monitorId,'userData':getUserInformation()});
    },[props.match.params.capid]);

    // 3 - Load camera metadata and saved urls from cloud images
    useEffect(() => {
        let isMounted = true;

        async function loadBigAndSmallCameras() {
            try {
                const cams = getCameras();
                if(cams==null || cams.capId !== cap.capId) {
                    const tempCams = await getMonitors(cap.capId);
                    if(isMounted) {
                        setLocalCameras(tempCams);
                        setCameras(tempCams);
                    }
                } else {
                    if(isMounted) {
                        setLocalCameras(cams);
                    }
                }
            } catch(e) {
                console.log(e);
            }
        }

        async function requestSavedCamera() {
            try {
                var tempImageUrls = getLatestUrls();
                if(tempImageUrls == null) {
                    tempImageUrls = await getLatestStoredImages(props.match.params.capid);
                    if(isMounted) {
                        storeLatestUrls(tempImageUrls);
                    }
                }
                if(isMounted) {
                    setSavedUrl(tempImageUrls[props.match.params.monitorid]);
                }
            } catch (e) {
                if(isMounted) {
                    setRenderError(true);
                }
                console.log(e);
            }
        }

        if(cap!=null) {
            if(isMounted) {
                setIsLoading(true);
                requestSavedCamera();
                loadBigAndSmallCameras();
                if(isMounted)
                    setIsLoading(false);
            }
        }
        return () => { isMounted = false; };
    },[cap]);

    // 4a - Set the different resolution monitors
    useEffect(() => {
        // monitorid in url is the high res stream (medium), get the grouping and assign the ultra res stream
        if(cap && localCameras) {
            const camerasAtDirection = getMonitorsGroupById(localCameras,props.match.params.monitorid);
            setBigCamera(camerasAtDirection.high);
            setMediumCamera(camerasAtDirection.medium);
        }
    },[localCameras]);

    // 4c - Load the low stream
    useEffect(() => {
        if(cap && savedUrl && bigCamera && mediumCamera) {
            if(!fullyLoaded && cap.health !== "POWER_LOSS" && cap.health !== "ERROR") {
                setStreaming(true);
                setUrl(`${URL_BASE}${cap.port-3000}/camera/${view}/low/index.m3u8`);
                setPlaying(true);
                if(playerRef.current) {
                    const hls = playerRef.current.getInternalPlayer('hls');
                    if(hls) {
                        hls.on(hls.Events.ERROR, function(event,data) {
                            console.log(event,data);
                        });
                    }
                }
                if(playerRefHigh.current) {
                    const hls = playerRefHigh.current.getInternalPlayer('hls');
                    if(hls) {
                        hls.on(hls.Events.ERROR, function(event,data) {
                            console.log(event,data);
                        });
                    }
                }
            }
        }
    },[cap,savedUrl, bigCamera, mediumCamera]);

    useEffect(() => {
        if(playing) setFullyLoaded(true);
    },[playing]);

    // Fixes URLs when stream quality changes
    useEffect(() => {
        if(streamQuality && cap) {
            if(streamQuality==="low" && streamTransition==="none") {
                setUrl(`${URL_BASE}${cap.port-3000}/camera/${view}/low/index.m3u8`);
                setStreamTransition("highToLow");
                // setUrlHigh("");
            } else if(streamQuality==="high" && streamTransition==="none") {
                setUrlHigh(`${URL_BASE}${cap.port-3000}/camera/${view}/high/index.m3u8`);
                setStreamTransition("lowToHigh");
                // setUrl("");
            }
        }
    },[streamQuality]);

    useEffect(() => {
        if(streamTransition==="highToLow" && lowSecondsLoaded && lowSecondsLoaded > 0) {
            setStreamTransition("none");
        }
    },[lowSecondsLoaded]);

    useEffect(() => {
        if(streamTransition==="lowToHigh" && highSecondsLoaded && highSecondsLoaded > 0) {
            setStreamTransition("none");
        }
    },[highSecondsLoaded]);

    async function playPause(play=true) {
        setPlayPauseLoading(true);
        if(streaming) {
            setImgDate(new Date());
            if(playerRef.current) {
                const hls = playerRef.current.getInternalPlayer('hls');
                if(hls) {
                    if(playing && !play) {
                        hls.stopLoad();
                        setPlaying(false);
                    } else if (!playing && play) {
                        hls.startLoad();
                        setPlaying(true);
                    }
                }
            }
            if(playerRefHigh.current) {
                const hls = playerRefHigh.current.getInternalPlayer('hls');
                if(hls) {
                    if(playing && !play) {
                        hls.stopLoad();
                        setPlaying(false);
                    } else if(!playing && play) {
                        hls.startLoad();
                        setPlaying(true);
                    }
                }
            }
        }
        // } else {
        //     setTime(0);
        // }
        setPlayPauseLoading(false);
    }

    // Useful for download button
    async function loadSnapshot() {
        setDownloadLoading(true);
        let tempSnapshot;
        if(bigCamera && streamQuality==="high") {
            try {
                tempSnapshot = await getImagesFromCapThroughCloud(cap,[bigCamera],null);
            } catch(e) {
                console.log("Not able to pull snapshot (high)",e);
                cameralogin(true);
            }
            if(tempSnapshot && bigCamera.monitorId in tempSnapshot) {
                if(componentMounted.current) {
                    // setLatestStreamImage(tempSnapshot[bigCamera.monitorId].url);
                    setDownloadLoading(false);
                    window.location.href = tempSnapshot[bigCamera.monitorId].url;
                }
            }
        } else if(mediumCamera && streamQuality==="low") {
            try {
                tempSnapshot = await getImagesFromCapThroughCloud(cap,[mediumCamera],null);
            } catch(e) {
                console.log("Not able to pull snapshot (med)", e);
                cameralogin(true);
            }
            if(tempSnapshot && mediumCamera.monitorId in tempSnapshot) {
                if(componentMounted.current) {
                    // setLatestStreamImage(tempSnapshot[mediumCamera.monitorId].url);
                    setDownloadLoading(false);
                    window.location.href = tempSnapshot[mediumCamera.monitorId].url;
                }
            }
        }
    }

    function renderLargeCamera() {
        const isLive = Boolean(streaming && fullyLoaded && playing &&
            ((lowSecondsLoaded && lowSecondsLoaded > 0) || (highSecondsLoaded && highSecondsLoaded > 0)));
        const isPaused = !playing && fullyLoaded;
        const isSwitching = streamTransition !== "none" && fullyLoaded && playing;
        const isInitialLoading = !fullyLoaded && streaming && playing;
        const dots = time%3===0 ? "." : time%3===1 ? ".." : "...";
        const statusText =
            cap && cap.health === "POWER_LOSS" ? "Power Outage" :
            cap && cap.health === "ERROR" ? "Waiting for Cell" :
            isPaused ? "Paused" :
            isSwitching ? "Switching"+dots :
            isLive ? "Live" :
            (streaming && playing) ? "Loading"+dots :
            "Paused";
        const statusClass =
            cap && (cap.health === "POWER_LOSS" || cap.health === "ERROR") ? "error" :
            isPaused ? "paused" :
            isSwitching ? "loading" :
            isLive ? "live" :
            "loading";
        const metaText =
            streaming && signalWeak ? "Connection is weak, stream may lag behind real time..." :
            !streaming && fullyLoaded ? "Stream timed out, refresh to reload the live view" :
            "";

        return (
            <div
                className="stream-stage"
                style={{"--stream-aspect": streamQuality === "high" ? "1.7684" : "1.466667"}}
            >
                <div className="stream-controls">
                    <span className={`stream-status stream-status--${statusClass}`}>
                        {statusText}
                    </span>
                    {isPaused && (
                        <LoaderButton
                            className="btn-brand-underline stream-refresh"
                            isLoading={playPauseLoading}
                            onClick={() => window.location.reload(false)}
                        >
                            <Glyphicon glyph="refresh" className="stream-glyph-front" />
                            Refresh
                        </LoaderButton>
                    )}
                    <div className="stream-controls-right">
                        <span className="stream-res-label">Stream Resolution</span>
                        <div className="stream-res-group">
                            <LoaderButton
                                className={`stream-res-btn ${streamQuality==="low" ? "stream-res-btn--active" : ""}`}
                                disabled={streamQuality==="low" || !playing || cap.health === "POWER_LOSS" || cap.health === "ERROR"}
                                isLoading={isSwitching && streamTransition==="highToLow"}
                                onClick={() => setStreamQuality("low")}
                            >Standard</LoaderButton>
                            <LoaderButton
                                className={`stream-res-btn ${streamQuality==="high" ? "stream-res-btn--active" : ""}`}
                                disabled={streamQuality==="high" || !playing || cap.health === "POWER_LOSS" || cap.health === "ERROR"}
                                isLoading={isSwitching && streamTransition==="lowToHigh"}
                                onClick={() => setStreamQuality("high")}
                            >High</LoaderButton>
                        </div>
                        <Button
                            className="stream-info-btn"
                            onClick={() => setShowResolutionHelp(!showResolutionHelp)}
                        ><Glyphicon glyph="info-sign" /></Button>
                        <Button
                            className="stream-info-btn"
                            title={isFullscreen ? "Exit full screen" : "Full screen"}
                            onClick={toggleFullscreen}
                        ><Glyphicon glyph={isFullscreen ? "resize-small" : "fullscreen"} /></Button>
                    </div>
                </div>
                <Collapse in={showResolutionHelp}>
                    <div>
                        <div className="stream-help">
                            <b>High Resolution:</b> If your site has a fast cellular connection, you can use this setting to pull the high-resolution stream. It will automatically pull the 4MP stream as fast as the cellular connection allows. If the stream keeps buffering, revert to the the Standard Stream.<br /><br />
                            <b>Standard Resolution:</b> We recommend using this resolution if the construction site's cellular connection is slow. Under normal conditions, this setting can pull a live feed at 24fps.
                        </div>
                    </div>
                </Collapse>
                {metaText !== "" && (
                    <div className="stream-meta">{metaText}</div>
                )}
                <div className="stream-video">
                    {(isSwitching || isInitialLoading) && (
                        <div className="stream-spinner-overlay" aria-hidden="true">
                            <span className="stream-spinner" />
                        </div>
                    )}
                    <TransformWrapper>
                        {() => (
                            (url || (savedUrl && savedUrl.url)) ? (
                                <TransformComponent wrapperStyle={{width:"100%",}} contentStyle={{width:"100%",}}>
                                    {componentMounted.current && (
                                        <>
                                            {url ? (
                                                <ReactPlayer
                                                    ref={playerRef}
                                                    url={url}
                                                    config={STREAM_PLAYER_CONFIG}
                                                    disableDeferredLoading
                                                    width='100%'
                                                    height='auto'
                                                    style={{position:'absolute',aspectRatio:1.466667,display:"block",zIndex:fullyLoaded ? ( streamQuality === "low" || streamTransition === "lowToHigh" ) ? 10 : 0 : 0, opacity:fullyLoaded ? ( streamQuality === "low" || streamTransition === "lowToHigh" ) ? 1 : 0 : 0}}
                                                    playsinline
                                                    playing={playing}
                                                    onStart={() => {
                                                        setFullyLoaded(true);
                                                    }}
                                                    onError={(error) => {
                                                        console.log("Low stream player error", error);
                                                    }}
                                                />
                                            ) : null}
                                            {urlHigh ? (
                                                <ReactPlayer
                                                    ref={playerRefHigh}
                                                    url={urlHigh}
                                                    config={STREAM_PLAYER_CONFIG}
                                                    disableDeferredLoading
                                                    width='100%'
                                                    height='auto'
                                                    style={{position:'absolute',aspectRatio:1.7684,display:'block',zIndex:fullyLoaded ? ( streamQuality === "high" || streamTransition === "highToLow" ) ? 10 : 0 : 0, opacity:fullyLoaded ? ( streamQuality === "high" || streamTransition === "highToLow" ) ? 1 : 0 : 0}}
                                                    playsinline
                                                    playing={playing}
                                                    onStart={() => {
                                                        setFullyLoaded(true);
                                                    }}
                                                    onError={(error) => {
                                                        console.log("High stream player error", error);
                                                    }}
                                                />
                                            ) : null}
                                            <img
                                                style={{width: "100%", height: "100%", cursor: "pointer", zIndex: ( fullyLoaded ) ? 0 : 10, opacity: (fullyLoaded && ((lowSecondsLoaded && lowSecondsLoaded > 0) || (highSecondsLoaded && highSecondsLoaded > 0))) ? 0 : 1}} 
                                                src={savedUrl.url}
                                                alt="Latest camera snapshot"
                                            />
                                        </>
                                    )}
                                </TransformComponent>
                            ) : <TransformComponent />
                        )}
                    </TransformWrapper>
                </div>
            </div>
        )
    }

    function renderMissing() {
        return (
            <div className="stream-missing">
                <h3>Stream cannot be found, please refresh or go back to all cameras</h3>
            </div>
        )
    }
    
    return (
        <div
            className="stream-overlay"
            ref={overlayRef}
            onMouseDown={(e) => {
                if(e.target === e.currentTarget) backToCaps();
            }}
        >
            <button
                type="button"
                className="stream-close"
                aria-label="Close live view"
                onClick={backToCaps}
            >
                &times;
            </button>
            {renderError ? renderMissing() : (!isLoading && renderLargeCamera())}
        </div>
    );
}